import React from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { useAudio } from '../context/AudioContext';

const AudioPlayer = () => {
    const { isMuted, toggleMute, isPlaying } = useAudio();

    return (
        <button
            onClick={toggleMute}
            className={`relative p-3 rounded-full transition-all duration-300 ${
                !isMuted && isPlaying 
                    ? 'bg-[#C8A86B] text-white music-pulse' 
                    : 'bg-[#D4DED5]/50 text-[#4A4E4D] hover:bg-[#D4DED5]'
            }`}
            aria-label={isMuted ? 'Unmute background music' : 'Mute background music'}
            data-testid="audio-toggle"
        >
            {isMuted ? (
                <VolumeX className="w-5 h-5" />
            ) : (
                <Volume2 className="w-5 h-5" />
            )}
        </button>
    );
};

export default AudioPlayer;
